import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";


import civilwork from "../images/Civil.jpg";
import Civilworks from "../images/civil 2.jpg";
import CivilWork3 from "../images/Civil work 2.jpg";
import Civile from "../images/Civil Work.jpg";






import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




import Header from "../inc/Header";

function Constraction() {
  return (
    <div>

      <Header />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div className='Civil Workdesign'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Constraction</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='az2service'>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={civilwork} className="card-img-top" alt="civilwork"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Civil Work </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2' style={{color:"white"}} href='tel: 9732000307'> Book Now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Civilworks} className="card-img-top" alt="Civil Workphoto"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Civil Work</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={CivilWork3} className="card-img-top" alt="Civil Work"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Civil Work </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Civile} className="card-img-top" alt="Civil Workimg"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Civil Work                                 </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

    

  <br />

      <br />


      </div>
    
    </div>
  )
}

export default Constraction